import throttle from 'lodash-es/throttle';
import {$$} from '@/scripts/utils/dom';

function setUpScrollIndicator(scrollElementSelector) {
  const selectorEls = $$(scrollElementSelector);
  const trackEls = $$('.scroll-indicator__track');
  const barEls = $$('.scroll-indicator__bar');
  const overlayEls = $$('.gradient-overlay');

  if (!selectorEls.length > 0) return;

  const selector = selectorEls[0];

  let clientWidth;
  let scrollWidth;

  function setDisplay(elements, display) {
    elements.forEach((element) => {
      element.style.display = display;
    });
  }

  function measure() {
    clientWidth = selector.clientWidth;
    scrollWidth = selector.scrollWidth;

    if (clientWidth === scrollWidth) {
      setDisplay(trackEls, 'none');
      setDisplay(overlayEls, 'none');
      return;
    }

    setDisplay(trackEls, '');
    setDisplay(overlayEls, '');
    barEls.forEach((bar) => {
      bar.style.width = `${(clientWidth / scrollWidth) * 100}%`;
    });
    setBarLeft();
  }

  function setBarLeft() {
    const scrollLeft = selector.scrollLeft;
    const percentMultiplier = clientWidth / scrollWidth;
    const leftPixelOffset = scrollLeft * percentMultiplier;

    const percentOffset = scrollLeft / scrollWidth;

    barEls.forEach((bar) => {
      bar.style.left = `${percentOffset * 100}%`;
    });
  }

  window.addEventListener('resize', throttle(measure, 100));
  selectorEls.forEach((element) => element.addEventListener('scroll', setBarLeft));

  measure();

  function checkScrollWidth() {
    if (scrollWidth !== selector.scrollWidth) measure(); // eslint-disable-line curly
    window.requestAnimationFrame(checkScrollWidth);
  }

  window.requestAnimationFrame(checkScrollWidth);
}

export default setUpScrollIndicator;